import { useEffect } from "react";
import { useSocket } from "./SocketProvider";

export function useSocketEvent<T = any>(event: string, handler: (payload: T) => void, enabled = true) {
  const { socket } = useSocket();

  useEffect(() => {
    if (!socket || !enabled) return;
    const h = (data: T) => handler(data);
    socket.on(event, h);
    return () => {
      socket.off(event, h);
    };
  }, [socket, event, enabled, handler]);
}
